// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for vls state system
// =============================================================================
// ---Third-party imports
import React, {useState, useEffect} from 'react'
import {Segment, Table, Grid, Header, Dropdown, Image} from 'semantic-ui-react'

// ---Framework imports
import {has, sorted, items, size, isArray, isNil, get} from 'ldash'
import {Actions} from 'uix/registries'
import {funcPart, Part} from 'uix/parts'
import log from 'uix/logging'
import {DomainConfigSegment} from 'uix/config/components'
import {XTab} from 'uix/components'
import connect from 'uix/connect'

// ---Local imports
import {translateState} from './'
import {loadStatesConfig} from './actions'
import {
  StateDropdown,
  StateIcon,
  getSortedStates,
  configLoaded,
  statesCompProps,
} from './components'
// ---Exports

let StateList = connect(
  'StateList',
  statesCompProps,
  ({dname, dstates, loadStatesConfig, i18n, Graphics}) => {
    if (!configLoaded(dname, dstates, loadStatesConfig)) {
      return null
    }

    let table = statusType => {
      let sortedStates = getSortedStates(dstates, statusType)
      let cols = [
        'mode',
        'group',
        'startstate',
        'nextstate',
        'endstate',
        'scan',
        'skipStructureImport',
        'orderpage',
        'stateOnNewImages',
        'zipcapsule',
        'modsReadonly',
      ]
      cols = cols.filter(col => items(dstates[statusType]).some(e => e[1][col]))
      let headers = cols.map(col => <Table.HeaderCell key={col}>{col}</Table.HeaderCell>)

      let format = e => {
        if (isArray(e)) {
          return e.join(',')
        } else if (isNil(e)) {
          return ''
        } else {
          return String(e)
        }
      }
      //~ log(Graphics.states)
      let rows = sortedStates.map(([name, state]) => (
        <Table.Row key={name}>
          <Table.Cell>
            {state.value}: {name}
          </Table.Cell>
          <Table.Cell>
            <StateIcon Graphics={Graphics} type={statusType} name={name} />
          </Table.Cell>
          <Table.Cell>{translateState(i18n, statusType, state.value)}</Table.Cell>
          {cols.map(col => (
            <Table.Cell key={col}>{format(state[col])}</Table.Cell>
          ))}
        </Table.Row>
      ))

      return (
        <Grid.Column key={statusType}>
          <Header>
            <StateIcon Graphics={Graphics} type={statusType} />
            <span style={{marginLeft: 10}}>
              {get(i18n, `${statusType}_state_tree`, statusType)} [{statusType}]
            </span>
            <span style={{marginLeft: 10}}>
              <StateDropdown statusType={statusType} />
            </span>
          </Header>
          <Table celled definition>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Icon</Table.HeaderCell>
                <Table.HeaderCell>I18n</Table.HeaderCell>
                {headers}
              </Table.Row>
            </Table.Header>
            <Table.Body>{rows}</Table.Body>
          </Table>
        </Grid.Column>
      )
    }
    let sortedStates = sorted(items(dstates), e => size(e[1]))
    let tables = sortedStates.map(([statusType, v]) => table(statusType))
    return (
      <Segment>
        <Grid columns={2} divided>
          <Grid.Row>{tables}</Grid.Row>
        </Grid>
      </Segment>
    )
  }
)

export const TestStates = funcPart({getGraphics: ['states']}, ({dconfig, Graphics}) => {
  //~ filterItems(dconfig.states.modes)
  let pane = (name, children) => ({menuItem: name, render: () => XTab.pane(children)})

  let panes = [
    pane('List', <StateList Graphics={Graphics} />),
    pane('Config', <DomainConfigSegment subheader="Statussystem" section="states" levels={3} />),
  ]
  return <XTab panes={panes} />
})
